export const environment = {
  production: false,
  local: false,
  apiUrl: 'https://crmapi.helilog.rrsolutionstest.it',
  apiBase: 'https://crmapi.helilog.rrsolutionstest.it/api',
  URL_AI: 'https://aiapi.helilog.rrsolutionstest.it/api/v1',
  URL_CHATBOT: 'https://chatbot.helilog.rrsolutionstest.it/app/',
  domainLoginUrls: {
    admin: 'https://helilogmainapi.rrsolutionstest.it/api/frontend/account/login',
    camo: 'https://heliloghtlapi.rrsolutionstest.it/api/frontend/htlAccount/login',
    pilot: 'https://heliloghtlapi.rrsolutionstest.it/api/v2/app/auth/login',
    maintenance: 'https://helilogmaintenanceapi.rrsolutionstest.it/api/app/maintenance/login',
  },
};
